import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconTypes, IconVariants } from '../../components/foundations/Icon';
import { TRANSLATION_KEY } from '../constants';
import { countKey } from '../utils';
import css from './MonitorStillChecking.css';

const TOAST_KEY = `${TRANSLATION_KEY}.TOASTS`;

const MonitorStillChecking = ({ count }) => {
    if (count <= 0) return null;

    return (
        <div className={css.stillChecking}>
            <Icon
                type={IconTypes.TABLER}
                name="binoculars"
                size={IconSizes.X_SMALL}
                variant={IconVariants.ACTIVE}
                interactive={false}
            />
            <span className={css.label}>
                <Translate id={`${TOAST_KEY}.${countKey('STILL_CHECKING', count)}`} data={{ count }} />
            </span>
        </div>
    );
};

MonitorStillChecking.propTypes = {
    count: PropTypes.number.isRequired,
};

export default MonitorStillChecking;
